import { Container, Row } from "reactstrap";
import GridOptions from "./GridOptions/GridOptions";
import { Breadcrumbs } from "../../../AbstractElements";
import { Grid, UIKits } from "../../../Constants/Constants";
import GridColumn from "./GridColumn";
import VerticalAlignment from "./VerticalAlignment";
import HorizontalAlignment from "./HorizontalAlignment";
import Nesting from "./Nesting/Nesting";
import Order from "./Order";
import OffSet from "./OffSet";
import { Fragment } from "react/jsx-runtime";
import EnableFlexBehaviors from "./EnableFlexBehaviors";
import HorizontalGutters from "./HorizontalGutters";
import VerticalGutters from "./VerticalGutters";
import RowColumnsGutters from "./RowColumnsGutters";
import NoGutters from "./NoGutters";

const GridContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Grid} parent={UIKits} />
      <Container fluid>
        <Row>
          <GridOptions />
          <GridColumn />
          <EnableFlexBehaviors />
          <HorizontalGutters />
          <VerticalGutters />
          <RowColumnsGutters />
          <NoGutters />
          <VerticalAlignment />
          <HorizontalAlignment />
          <Nesting />
          <Order />
          <OffSet />
        </Row>
      </Container>
    </Fragment>
  );
};
export default GridContainer;
